import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import PrimeLayout from "../components/PrimeLayout";
import StyledSelect from "../components/elements/StyledSelect";
import { Grid } from "@mui/material";
import StyledButton from "../components/elements/StyledButton";
import {
  reqStatusArray,
  requestModelAccessDialogTableHeader,
  requestModelTableHeaders,
} from "../constants/Data";
import DatePicker from "../components/elements/DatePicker";
import { IoMdUnlock } from "react-icons/io";
import { BiSearchAlt } from "react-icons/bi";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import {
  DialogContentWrapper,
  IconWrapper,
  MiniModalContentTitle,
  MiniModalContentBody,
} from "../components/styled/ReqModel.styled";
import StyledTable from "../components/StyledTable";
import DialogWrapper from "../components/DialogWrapper";
import RequestModelAccessTable from "../components/RequestModelTable";
import MiniModal from "../components/MiniModal";
import {
  getAllModels,
  getAllRequests,
  getPermission,
} from "../services/api/reqModel.api";
import { getCurrentUserDetails } from "../services/api/users.api.js";
import { toast } from "react-toastify";
import { BackDrop } from "../components/elements/Loader";
import Pagination from "../components/elements/Pagination";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {getAllCountries} from "../services/api/country.api";

export default function ReqModel() {
  const [status, setStatus] = useState("init");
  const [model, setModel] = useState("init");
  const [country, setCountry] = useState("init");
  const [order, setOrder] = useState({ id: "name", sort: "asc" });
  const [dataRows, setDataRows] = useState([]);
  const [requestTableRows, setRequestTableRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMiniModal, setIsOpenMiniModal] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [loadingPermissionAccessRequest, setLoadingPermissionAccessRequest] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [requestOrder, setRequestOrder] = useState({
    id: "requested_date",
    sort: "asc",
  });
  const [reqModel, setReqModel] = useState();
  const [render, setRender] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [page, setPage] = useState(1);
  const [requests, setRequests] = useState({});
  const [modelOptions, setModelOptions] = useState([]);
  const [countries,setCountries] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (
        user?.user_role !== "admin" &&
        user?.user_role !== "super_admin" &&
        user?.user_role !== "user" &&
        user?.user_role !== "reporting"
      ) {
        toast.error("You do not have access to this page");
        return navigate("/");
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    const getCountries = async()=>{
      try{
        let response = await getAllCountries();
        setCountries(response);
      }catch(err){
        console.log(err);
        toast.error(err.message, { theme: "colored" });
      }
    }
    getCountries();
    // eslint-disable-next-line
  },[]);

  const getPage = (p) => {
    setPage(p);
  };

  const searchArray = async () => {
    try {
      setPage(1)
      setLoading(true);
      // obtain local UTC offset and convert to msec to T00:00:00.000Z --> dateRange[0].getTimezoneOffset() * 60000
      const dateFrom = dateRange[0]
        ? new Date(
            dateRange[0] - dateRange[0].getTimezoneOffset() * 60000
          ).toISOString()
        : null;
      // obtain local UTC offset and convert to msec to 23:59:00.000Z --> dateRange[1].getTimezoneOffset() * ((23 + ( 59/ 60 ) + 5.5 ) / 5.5) * 60000
      const dateTo = dateRange[1]
        ? new Date(
            dateRange[1] -
              dateRange[1].getTimezoneOffset() *
                ((23 + 59 / 60 + 5.5) / 5.5) *
                60000
          ).toISOString()
        : null;
      const requestsAll = await getAllRequests({
        limit: 10,
        offset: page,
        key: requestOrder.id,
        order: requestOrder.sort,
        userId: user._id,
        country: country === "init" ? null : country,
        template: model === "init" ? null : model,
        status: status === "init" || status === "all" ? null : status,
        dateFrom: dateFrom,
        dateTo: dateTo,
      });
      //setModelOptions(requestsAll.models);
      const requestData = requestsAll.docs.map((data) => {
        return {
          id: data._id,
          template: data.template.name,
          headers: data.template.headers,
          countries: data.template.countries,
          requested_date: moment(data.requested_date).format(
            "DD/MM/YYYY, HH:mm"
          ),
          status: data.status,
          reason: data.reason ? data.reason : "N/A",
        };
      });
      setRequests(requestsAll);
      setDataRows([...requestData]);
      setLoading(false);
    } catch (err) {
      if (err.message === "No active account") {
        toast.error("Session Expired, Please Log back", {
          theme: "colored",
        });
        return navigate("/");
      }
      if (err.response)
        return toast.error(err.response.data.error.message, {
          theme: "colored",
        });
      toast.error(err.message, { theme: "colored" });
    }
  };

  const clickOnRequestAccess = async (event) => {
    try {
      const permissionData = {
        req_user: {
          user_id: user._id,
          name: user.name,
        },
        template: {
          template_id: event.id,
          name: event.name,
          countries: event.countries,
          headers: event.headers,
        },
      };
      setLoadingPermissionAccessRequest(true);
      const success = await getPermission(permissionData);
      setReqModel(event.name);
      if (success) {
        setLoadingPermissionAccessRequest(false);
        setIsOpen(false);
        setIsOpenMiniModal(true);
        setRender(!render);
      }
      setLoadingPermissionAccessRequest(false);
    } catch (err) {
      setLoadingPermissionAccessRequest(false);
      if (err.message === "No active account") {
        toast.error("Session Expired, Please Log back", {
          theme: "colored",
        });
        return navigate("/");
      }
      if (err.response.data.error.message)
        return toast.error(err.response.data.error.message, {
          theme: "colored",
        });
      toast.error(err.message, { theme: "colored" });
    }
    // send API call to request access
    //return toast.success("Request send successfully.", { theme: "colored" });
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        setLoading(true);
        const requestsAll = await getAllRequests({
          limit: 10,
          offset: page,
          key: requestOrder.id,
          order: requestOrder.sort,
          userId: user && user._id,
        });
        //setModelOptions(requestsAll.models);
        let modelsForFilter = []
        const requestData = requestsAll.docs.map((data) => {
          modelsForFilter.push(data.template.name)
          return {
            id: data._id,
            template: data.template.name,
            headers: data.template.headers,
            countries: data.template.countries,
            requested_date: moment(data.requested_date).format(
              "DD/MM/YYYY, HH:mm"
            ),
            status: data.status,
            reason: data.reason ? data.reason : "N/A",
          };
        });
        setModelOptions([...modelsForFilter])
        setRequests(requestsAll);
        setDataRows([...requestData]);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        if (err.message === "No active account") {
          toast.error("Session Expired, Please Log back", {
            theme: "colored",
          });
          return navigate("/");
        }
        if (err.response)
          return toast.error(err.response.data.error.message, {
            theme: "colored",
          });
        toast.error(err.message, { theme: "colored" });
      }
    };
      fetchPermissions();
      // eslint-disable-next-line
  }, [render, requestOrder, page, navigate]);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        setLoading(true);
        const response = await getAllModels({
          limit: 100000000,
          offset: page,
          key: order.id,
          order: order.sort,
        });

        const requestRows = response.docs.map((doc) => {
          return {
            id: doc._id,
            name: doc.name,
            headers: doc.headers,
            countries: doc.countries.map((country) => {
              return country.country;
            }),
            RequestAccess: "Request Access",
          };
        });
        const userDetails = await getCurrentUserDetails();
        //let allowedTemplates = [];
        let templatesToBeRequested = [];
        requestRows.map((item) => {
          let isExists = false;
          userDetails.templates.map((template) => {
            if (template.template_id === item.id) {
              isExists = true;
            }
            return null;
          });
          if (!isExists) {
            templatesToBeRequested.push(item);
          } /*else {
            allowedTemplates.push(item.name);
          }*/
          return null;
        });

        setRequestTableRows([...templatesToBeRequested]);
        //setModelOptions([...allowedTemplates]);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        
      }
    };
    fetchModels();
    // eslint-disable-next-line
  }, [order, page]);

  return (
    <div>
      <Header />
      <Banner small />
      <PrimeLayout title={"Request Module Access"}>
        <DialogWrapper
          title={"Request Module Access"}
          cancelLabel="Cancel"
          open={isOpen}
          setOpenModal={setIsOpen}
          cancelAction={() => {
            setIsOpen(false);
          }}
          onClose={() => {
            setIsOpen(false);
          }}
        >
          {loadingPermissionAccessRequest ? (
            <>
              <BackDrop />
            </>
          ) : (
            <RequestModelAccessTable
              headCells={requestModelAccessDialogTableHeader}
              rows={requestTableRows}
              order={order}
              setOrder={setOrder}
              clickOnRequestAccess={clickOnRequestAccess}
            />
          )}
        </DialogWrapper>
        <MiniModal
          title={"Request Sent"}
          open={isOpenMiniModal}
          setOpenModal={setIsOpenMiniModal}
          onClose={() => {
            setIsOpenMiniModal(false);
          }}
          confirmationLabel={"OK"}
        >
          <DialogContentWrapper>
            <IconWrapper>
              <IoCheckmarkCircleOutline />
            </IconWrapper>
            <MiniModalContentTitle>
              Module access request successfully sent
            </MiniModalContentTitle>
            <MiniModalContentBody>
              Your {reqModel} module access request has been sent successfully
              to your admin, he/she will review your request and notify you.
            </MiniModalContentBody>
          </DialogContentWrapper>
        </MiniModal>
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="flex-start"
          spacing={3}
        >
          <Grid item xs={12} md={3} lg={2}>
            <StyledSelect
              label={"Status"}
              defaultVal={"Select the Status"}
              options={reqStatusArray}
              control={status}
              setControl={setStatus}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <StyledSelect
              label={"Module"}
              defaultVal={"Select the Module"}
              options={modelOptions}
              control={model}
              setControl={setModel}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <StyledSelect
              label={"Country"}
              defaultVal={"Select the Country"}
              options={countries}
              control={country}
              setControl={setCountry}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <DatePicker dateRange={dateRange} setDateRange={setDateRange} />
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={3}
            justifyContent={"flex-end"}
            alignItems={"center"}
          >
            <StyledButton
              iconLeft={<BiSearchAlt size={25} />}
              variant={"outlined"}
              style={{ marginTop: "25px" }}
              onClick={() => {
                searchArray();
              }}
            >
              Search
            </StyledButton>
          </Grid>
          <Grid xs={12} md={12} lg={6}>
            <StyledButton
              variant={"contained"}
              iconLeft={<IoMdUnlock />}
              onClick={() => {
                setIsOpen(true);
              }}
            >
              Request Access for New Module
            </StyledButton>
          </Grid>
        </Grid>
        <StyledTable
          headCells={requestModelTableHeaders}
          rows={dataRows}
          order={requestOrder}
          loading={loading}
          setOrder={setRequestOrder}
          chips={"status"}
        />
        {requests.totalPages > 1 && !loading && (
          <Pagination
            count={requests.totalPages}
            getPage={getPage}
            page={page}
          />
        )}
      </PrimeLayout>
    </div>
  );
}
